import {IssueStatus} from "../domain/entities/issue-status.entity";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/**
 * Command to recolor an existing issue status entity.
 */
export class RecolorIssueStatusCommand extends AbstractCommand<IssueStatus> {

    public name = CommandName.RECOLOR_ISSUE_STATUS;

    public tags: string[] = [`entity`, `update`, `issue-status`];

    constructor(payload: IssueStatus) {
        super('issue-status', payload.uid, payload);
    }
}
